import {Directive, HostListener} from '@angular/core'

@Directive({
  selector: '[copyFormatExcel]',
  standalone: false,
})
export class CopyFormatExcelDirective {
  @HostListener('copy', ['$event'])
  onCopy(event) {
    this.handleCopy(event)
  }

  handleCopy(event) {
    event.preventDefault()
    let contentByRow = []
    let textValues = []
    document
      .getSelection()
      .getRangeAt(0)
      .cloneRange()
      .cloneContents()
      .childNodes.forEach((item) => {
        item.childNodes.forEach((it) => {
          if (!['Comment', 'Text'].includes(it.constructor.name)) {
            contentByRow = [...contentByRow, this.getAsArray(it)]
          }
          // catch text values and store them in an array
          if (it.constructor.name === 'Text') {
            textValues = [...textValues, it.textContent]
          }
        })
        // handle a string selection
        if (!item.childNodes.length) {
          contentByRow = [[item.nodeValue]]
        }
      })
    // it was just one row
    if (textValues.length) {
      contentByRow = [...contentByRow, textValues]
    }
    // now write to clipboard (separate rows by newline, columns by tab)
    navigator.clipboard.writeText(
      contentByRow
        .map((row) => {
          return row.join('\t')
        })
        .join('\n'),
    )
  }

  getAsArray(htmlFragment) {
    return [...htmlFragment.getElementsByTagName('*')].reduce(
      (acc, element) => {
        if (
          element.children.length === 0 &&
          element.textContent.replace(/ |\n/g, '') !== ''
        ) {
          // Check the element has no children && that it is not empty
          acc = [...acc, element.textContent]
        }
        return acc
      },
      [],
    )
  }
}
